import React from 'react'
import { NavLink } from 'react-router-dom';
import {MDBNavItem,MDBDropdown,MDBDropdownToggle,MDBIcon
,MDBDropdownMenu,MDBNavLink,MDBDropdownItem} from 'mdbreact'
const SignedOutLinks = () => {
    return (
        <MDBNavItem>
        <MDBDropdown>
          <MDBDropdownToggle nav caret>
            <MDBIcon icon="user" />
          </MDBDropdownToggle>
          <MDBDropdownMenu className="dropdown-default">
          <MDBNavLink  className="nav-link black-text" to="/signup">Signup</MDBNavLink>
           <MDBNavLink  className="nav-link black-text" to="/login">Login</MDBNavLink>
          </MDBDropdownMenu>
        </MDBDropdown>
      </MDBNavItem>

    )
}
export default SignedOutLinks;